// Simple privacy-respecting analytics
class Analytics {
  constructor() {
    this.enabled = this.checkConsent();
    this.queue = [];
  }

  checkConsent() {
    try {
      const consent = localStorage.getItem('lexora-cookie-consent');
      if (consent) {
        const data = JSON.parse(consent);
        return data.preferences.analytics;
      }
      return false;
    } catch {
      return false;
    }
  }

  track(event, properties = {}) {
    if (!this.enabled) {
      this.queue.push({ event, properties, timestamp: Date.now() });
      return;
    }

    // Use Plausible for privacy-respecting analytics
    if (window.plausible) {
      window.plausible(event, { props: properties });
    }

    // Fallback to console for development
    if (process.env.NODE_ENV === 'development') {
      console.log('📊 Analytics:', event, properties);
    }
  }

  enable() {
    this.enabled = true;
    
    // Process queued events
    this.queue.forEach(({ event, properties }) => {
      this.track(event, properties);
    });
    this.queue = [];
  }

  disable() {
    this.enabled = false;
  }

  // Common tracking methods
  trackPageView(page) {
    this.track('pageview', { page });
  }

  trackBookingStarted() {
    this.track('booking_started');
  }

  trackBookingCompleted(amount, currency = 'EUR') {
    this.track('booking_completed', { amount, currency });
  }

  trackPaymentCompleted(amount, currency = 'EUR') {
    this.track('payment_completed', { amount, currency });
  }

  trackSignUp(method = 'email') {
    this.track('sign_up', { method });
  }

  trackLoginAttempt(method = 'email') {
    this.track('login_attempt', { method });
  }

  trackContactFormSubmitted() {
    this.track('contact_form_submitted');
  }

  trackLanguageChanged(language) {
    this.track('language_changed', { language });
  }

  trackSearchPerformed(query) {
    this.track('search_performed', { query });
  }

  trackErrorOccurred(error, context = '') {
    this.track('error_occurred', { error: error.message, context });
  }
}

// Create global analytics instance
const analytics = new Analytics();

// Listen for consent changes
window.addEventListener('storage', (e) => {
  if (e.key === 'lexora-cookie-consent') {
    if (analytics.checkConsent()) {
      analytics.enable();
    } else {
      analytics.disable();
    }
  }
});

export default analytics;